/**
 * 文件说明:
 *
 * crm 环境变量配置
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import baseConfig from 'config/index'
import {dvaNamespacePrefix} from '../_hz-project/hz-project-common'

const config = require(`./${HUZAN_ENV}.js`).default

export default {
    dvaNamespacePrefix,
    apiHost: baseConfig?.apiHost ?? '',
    ...config,
}
